import React from 'react'
import PropTypes from 'prop-types'
import t from "../../helpers/I18n";


const ProgressBar = ({title, loaded, isDesktop}) => {

    const className = "progress-bar"
    const classNameDesktop = title === " " ? "progress-bar-desktop no-title" : "progress-bar-desktop"


    const style = {
        width: loaded+"%",
    }

    if(isDesktop) {
        return (
            <div className={classNameDesktop}>
                {loaded ?
                <div className="back-button" onClick={()=> { window.history.back();}}>
                    <div className={"fonticons-arrow-back-ios"}></div>
                    {t('back')}
                </div> : ""}

                <div className={ "title"}>
                    {title}
                </div>

                {loaded ?
                <div className="progress" >
                    <div className="progress-in" style={style}></div>
                </div> : ""}

            </div>
        )
    } else {
        return (
            <div className={className}>
                {loaded ?
                <div className="back-button" onClick={()=> { window.history.back();}}>

                    <div className={"fonticons-arrow-back"}></div>

                </div> :""}

                <div className="title">
                    {title}
                </div>

                {loaded ?
                <div className="progress" >
                    <div className="progress-in" style={style}></div>
                </div> : ""}

            </div>
        )
    }


}

ProgressBar.propTypes = {
    title: PropTypes.string,
    loaded: PropTypes.number,
    isDesktop: PropTypes.bool,
}



export default ProgressBar